import {Box, Container, Grid, Typography} from "@mui/material";
import {CustomButton} from "../../../../shared/components/Buttons/CustomButton";
import {LinkButton} from "../../../../shared/components";
import {useLangContext} from "../../../../shared/features/Language";
import {useConsumerArtApi} from "../../api";
import {ImageContext} from "../../../../shared/tools/image/imageContext";
import {useHistory} from "react-router";
import {useContext, useCallback} from "react";
import FileSaver from "file-saver";

export const EmailSendView = () => {
  const {textData} = useLangContext();
  const {downloadPDF} = useConsumerArtApi();
  const history = useHistory();
  const {sessionId} = useContext(ImageContext);

  const startHandler = useCallback(async () => {
    history.push(`/assembly/${sessionId}`);
  }, []);

  const getPdfHandler = useCallback(async () => {
    try {
      const result = await downloadPDF();
      const csvFile = new Blob([result], {type: "application/pdf"});
      FileSaver.saveAs(csvFile, "YourInstruction.pdf");
    } catch (e) {
      console.error(e);
    }
  }, [downloadPDF]);

  return (
    <Container
      sx={{
        height: '100%',
        width: '100%',
        marginInline: 'auto',
      }}
    >
      <Box sx={{
        textAlign: 'center',
      }}>
        <Typography
          variant='body2'
          className='typography-body2'
          sx={{
            marginTop: {lg: '50px', xs: '10px'},
            marginBottom: {lg: '50px', xs: '10px'},
          }}
        >{textData.emailInstruction}</Typography>
        <Grid container
          sx={{
            gap: '50px',
            justifyContent: 'center',
          }}
        >
          <Grid item>
            <CustomButton
              color='primary'
              width={{lg: '450px', xs: '250px'}}
              onClick={startHandler}
            >{textData.buttonCaptionStartAssembly}</CustomButton>
          </Grid>
          <Grid item>
            <CustomButton
              color='primary'
              width={{lg: '450px', xs: '250px'}}
              onClick={getPdfHandler}
            >{textData.buttonCaptionGetPDF}</CustomButton>
          </Grid>
          <Grid item>
            <LinkButton
              to='/'
              color='secondary'
              width={{lg: '450px', xs: '250px'}}
            >{textData.buttonCaptionGoHome}</LinkButton>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
